export const formatUSD = (n) => {
  const safe = Number.isFinite(n) ? n : 0;
  return `$${safe.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const formatNum = (n) => {
  const safe = Number.isFinite(n) ? n : 0;
  return safe.toLocaleString("en-US");
};

export const rateLabel = (r) =>
  `$${(Number.isFinite(r) ? r : 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  })}/coin`;
